@if (!isExternalWindow && !hideNavigation()) {
  @if (isMobile() && showWorkspaceImmediately()) {
    <wf-navigation-mobile>
      @if (navSlot(); as slot) {
        <ng-container
          mobile-header
          *ngTemplateOutlet="slot.template; injector: slot.injector"
        />
      } @else {
        <context-selector mobile-header />
      }
    </wf-navigation-mobile>
  }

  @if (!isMobile() || !showWorkspaceImmediately()) {
    <wf-navigation
      class="page-container__nav-container"
      [showImmediately]="showWorkspaceImmediately()"
      [hideImmediately]="hideWorkspaceImmediately()"
      (sizeChange)="navSize.set($event)"
    >
      <ng-container bar-header>
        @if (navSlot(); as slot) {
          <ng-container
            *ngTemplateOutlet="slot.template; injector: slot.injector"
          />
        } @else {
          <context-selector
            (onMenuOpen)="onContextSelectorMenuOpen()"
            (onMenuClose)="onContextSelectorMenuClose()"
          />
        }
      </ng-container>

      <ng-container workspace-header>
        @if (workspaceSlot(); as slot) {
          <ng-container
            *ngTemplateOutlet="slot.template; injector: slot.injector"
          />
        } @else {
          <context-selector />
        }
      </ng-container>
    </wf-navigation>
  }
}

<div
  [style.padding-left.px]="paddingSize()"
  class="page-container__context-content"
>
  @if (topBannerSvc.slots().length) {
    <div #topBannerContainer class="page-container__top-banner">
      @for (slot of topBannerSvc.slots(); track slot) {
        <ng-container
          *ngTemplateOutlet="slot.template; injector: slot.injector"
        />
      }
    </div>
  }

  @if (!hideNavigation()) {
    @if (isMobile() && showWorkspaceImmediately()) {
      @if (logo$ | async; as logo) {
        <ng-template topNavigationSlot="start">
          <a routerLink="/" class="page-container__logo">
            <img [src]="logo | blob | async" alt="Logo" />
          </a>
        </ng-template>
      }

      <ng-template topNavigationSlot="end">
        <button
          wui-button
          class="page-container__menu-btn"
          (click)="openMobileMenu()"
        >
          <wf-icon iconName="menu-04" />
          @if (hasBadges()) {
            <span class="page-container__menu-badge"></span>
          }
        </button>
      </ng-template>
    }

    <div class="page-container__top-row">
      <top-navigation class="page-container__top-navigation" />
    </div>
  }
  <ng-content />
</div>
